// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/ref.proto (package no.jotta.openapi, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { FederationIntent } from "./federation_pb.js";
import { StripeClientState } from "./subscription/payment.v2_pb.js";
/**
 * @generated from message no.jotta.openapi.FileOrFolderRef
 */
export class FileOrFolderRef extends Message {
    /**
     * @generated from field: string path = 1;
     */
    path = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.FileOrFolderRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new FileOrFolderRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FileOrFolderRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FileOrFolderRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FileOrFolderRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.FileRevisionRef
 */
export class FileRevisionRef extends Message {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    /**
     * @generated from field: string checksum = 2;
     */
    checksum = "";
    /**
     * @generated from field: optional string path = 3;
     */
    path;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.FileRevisionRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "checksum", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new FileRevisionRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FileRevisionRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FileRevisionRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FileRevisionRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.PhotoRef
 */
export class PhotoRef extends Message {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    /**
     * @generated from field: string checksum = 2;
     */
    checksum = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.PhotoRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "checksum", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PhotoRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhotoRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhotoRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhotoRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.FaceRef
 */
export class FaceRef extends Message {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    /**
     * @generated from field: string checksum = 2;
     */
    checksum = "";
    /**
     * @generated from field: double left = 3;
     */
    left = 0;
    /**
     * @generated from field: double top = 4;
     */
    top = 0;
    /**
     * @generated from field: double right = 5;
     */
    right = 0;
    /**
     * @generated from field: double bottom = 6;
     */
    bottom = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.FaceRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "checksum", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "left", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
        { no: 4, name: "top", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
        { no: 5, name: "right", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
        { no: 6, name: "bottom", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    ]);
    static fromBinary(bytes, options) {
        return new FaceRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FaceRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FaceRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FaceRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.PhotoInAlbumRef
 */
export class PhotoInAlbumRef extends Message {
    /**
     * @generated from field: string photo_id = 1;
     */
    photoId = "";
    /**
     * @generated from field: string album_id = 2;
     */
    albumId = "";
    /**
     * @generated from field: string share_id = 3;
     */
    shareId = "";
    /**
     * @generated from field: no.jotta.openapi.PhotoRef photo = 4;
     */
    photo;
    /**
     * @generated from field: int64 index = 5;
     */
    index = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.PhotoInAlbumRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "album_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "share_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "photo", kind: "message", T: PhotoRef },
        { no: 5, name: "index", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new PhotoInAlbumRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhotoInAlbumRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhotoInAlbumRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhotoInAlbumRef, a, b);
    }
}
/**
 * TODO how do we reference an album actually?
 *
 * @generated from message no.jotta.openapi.PhotoAlbumRef
 */
export class PhotoAlbumRef extends Message {
    /**
     * @generated from field: string id = 1;
     */
    id = "";
    /**
     * @generated from field: string share_id = 2;
     */
    shareId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.PhotoAlbumRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "share_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PhotoAlbumRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhotoAlbumRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhotoAlbumRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhotoAlbumRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.CommentRef
 */
export class CommentRef extends Message {
    /**
     * @generated from field: string id = 1;
     */
    id = "";
    /**
     * @generated from field: string parent_id = 2;
     */
    parentId = "";
    /**
     * @generated from oneof no.jotta.openapi.CommentRef.item
     */
    item = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.CommentRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 100, name: "photo_in_album", kind: "message", T: PhotoInAlbumRef, oneof: "item" },
        { no: 101, name: "photo_album", kind: "message", T: PhotoAlbumRef, oneof: "item" },
    ]);
    static fromBinary(bytes, options) {
        return new CommentRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommentRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommentRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommentRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.TrashRef
 */
export class TrashRef extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.TrashRef";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new TrashRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TrashRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TrashRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TrashRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.ArchiveRef
 */
export class ArchiveRef extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.ArchiveRef";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ArchiveRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.SyncFolderRef
 */
export class SyncFolderRef extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.SyncFolderRef";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new SyncFolderRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncFolderRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncFolderRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncFolderRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.SettingsRef
 */
export class SettingsRef extends Message {
    /**
     * @generated from oneof no.jotta.openapi.SettingsRef.section
     */
    section = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.SettingsRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "notifications", kind: "message", T: SettingsRef_Notifications, oneof: "section" },
        { no: 2, name: "security", kind: "message", T: SettingsRef_Security, oneof: "section" },
        { no: 3, name: "payment_info", kind: "message", T: SettingsRef_PaymentInfo, oneof: "section" },
    ]);
    static fromBinary(bytes, options) {
        return new SettingsRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SettingsRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SettingsRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SettingsRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.SettingsRef.Notifications
 */
export class SettingsRef_Notifications extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.SettingsRef.Notifications";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new SettingsRef_Notifications().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SettingsRef_Notifications().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SettingsRef_Notifications().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SettingsRef_Notifications, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.SettingsRef.Notifications.Type
 */
export var SettingsRef_Notifications_Type;
(function (SettingsRef_Notifications_Type) {
    /**
     * @generated from enum value: UNKNOWN_NOTIFICATION_SETTING = 0;
     */
    SettingsRef_Notifications_Type[SettingsRef_Notifications_Type["UNKNOWN_NOTIFICATION_SETTING"] = 0] = "UNKNOWN_NOTIFICATION_SETTING";
    /**
     * @generated from enum value: NEWSLETTER = 1;
     */
    SettingsRef_Notifications_Type[SettingsRef_Notifications_Type["NEWSLETTER"] = 1] = "NEWSLETTER";
    /**
     * @generated from enum value: EXCESSIVE_TRASH = 2;
     */
    SettingsRef_Notifications_Type[SettingsRef_Notifications_Type["EXCESSIVE_TRASH"] = 2] = "EXCESSIVE_TRASH";
    /**
     * @generated from enum value: APP_NOTIFICATIONS = 3;
     */
    SettingsRef_Notifications_Type[SettingsRef_Notifications_Type["APP_NOTIFICATIONS"] = 3] = "APP_NOTIFICATIONS";
    /**
     * @generated from enum value: EMAIL_NOTIFICATIONS = 4;
     */
    SettingsRef_Notifications_Type[SettingsRef_Notifications_Type["EMAIL_NOTIFICATIONS"] = 4] = "EMAIL_NOTIFICATIONS";
})(SettingsRef_Notifications_Type || (SettingsRef_Notifications_Type = {}));
// Retrieve enum metadata with: proto3.getEnumType(SettingsRef_Notifications_Type)
proto3.util.setEnumType(SettingsRef_Notifications_Type, "no.jotta.openapi.SettingsRef.Notifications.Type", [
    { no: 0, name: "UNKNOWN_NOTIFICATION_SETTING" },
    { no: 1, name: "NEWSLETTER" },
    { no: 2, name: "EXCESSIVE_TRASH" },
    { no: 3, name: "APP_NOTIFICATIONS" },
    { no: 4, name: "EMAIL_NOTIFICATIONS" },
]);
/**
 * @generated from message no.jotta.openapi.SettingsRef.Security
 */
export class SettingsRef_Security extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.SettingsRef.Security";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new SettingsRef_Security().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SettingsRef_Security().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SettingsRef_Security().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SettingsRef_Security, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.SettingsRef.PaymentInfo
 */
export class SettingsRef_PaymentInfo extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.SettingsRef.PaymentInfo";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new SettingsRef_PaymentInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SettingsRef_PaymentInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SettingsRef_PaymentInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SettingsRef_PaymentInfo, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.PurchaseRef
 */
export class PurchaseRef extends Message {
    /**
     * @generated from oneof no.jotta.openapi.PurchaseRef.type
     */
    type = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.PurchaseRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "upgrade", kind: "message", T: PurchaseRef_Upgrade, oneof: "type" },
        { no: 2, name: "renew", kind: "message", T: PurchaseRef_Renew, oneof: "type" },
    ]);
    static fromBinary(bytes, options) {
        return new PurchaseRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurchaseRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurchaseRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PurchaseRef, a, b);
    }
}
/**
 * Upgrade links to the /upgrade page, or somewhere equivalent.
 *
 * @generated from message no.jotta.openapi.PurchaseRef.Upgrade
 */
export class PurchaseRef_Upgrade extends Message {
    /**
     * when product_code is set, we try to redirect directly to the upgrade _to_ the given product_code.
     *
     * @generated from field: string product_code = 1;
     */
    productCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.PurchaseRef.Upgrade";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "product_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PurchaseRef_Upgrade().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurchaseRef_Upgrade().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurchaseRef_Upgrade().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PurchaseRef_Upgrade, a, b);
    }
}
/**
 * Renew links to the /renew page, or somewhere equivalent
 *
 * @generated from message no.jotta.openapi.PurchaseRef.Renew
 */
export class PurchaseRef_Renew extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.PurchaseRef.Renew";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new PurchaseRef_Renew().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurchaseRef_Renew().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurchaseRef_Renew().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PurchaseRef_Renew, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.OrderRef
 */
export class OrderRef extends Message {
    /**
     * @generated from field: string order_number = 1;
     */
    orderNumber = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.OrderRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new OrderRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OrderRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OrderRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OrderRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.PublicShareRef
 */
export class PublicShareRef extends Message {
    /**
     * @generated from field: string share_id = 3;
     */
    shareId = "";
    /**
     * @generated from field: string path = 4;
     */
    path = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.PublicShareRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 3, name: "share_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PublicShareRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PublicShareRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PublicShareRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PublicShareRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.ExternalLinkRef
 */
export class ExternalLinkRef extends Message {
    /**
     * @generated from field: string link = 1;
     */
    link = "";
    /**
     * @generated from field: string signature = 2;
     */
    signature = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.ExternalLinkRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new ExternalLinkRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExternalLinkRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExternalLinkRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExternalLinkRef, a, b);
    }
}
/**
 * reference to the photos app in general, such as loading photos app on web,
 * and not a ref to a specific photo.
 *
 * @generated from message no.jotta.openapi.PhotosRef
 */
export class PhotosRef extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.PhotosRef";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new PhotosRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhotosRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhotosRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhotosRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.HelpArticle
 */
export class HelpArticle extends Message {
    /**
     * @generated from field: string article_id = 1;
     */
    articleId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.HelpArticle";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "article_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new HelpArticle().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new HelpArticle().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new HelpArticle().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(HelpArticle, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.FederatedIdentityRef
 */
export class FederatedIdentityRef extends Message {
    /**
     * @generated from field: string token = 1;
     */
    token = "";
    /**
     * @generated from field: no.jotta.openapi.FederationIntent intent = 2;
     */
    intent;
    /**
     * @generated from field: string provider_id = 3;
     */
    providerId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.FederatedIdentityRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "intent", kind: "message", T: FederationIntent },
        { no: 3, name: "provider_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new FederatedIdentityRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FederatedIdentityRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FederatedIdentityRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FederatedIdentityRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.VippsFlowRef
 */
export class VippsFlowRef extends Message {
    /**
     * @generated from field: string flow_id = 1;
     */
    flowId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.VippsFlowRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "flow_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new VippsFlowRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VippsFlowRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VippsFlowRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VippsFlowRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.PayPalFlowRef
 */
export class PayPalFlowRef extends Message {
    /**
     * @generated from field: string order_number = 1;
     */
    orderNumber = "";
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.StripeClientState client_state = 2;
     */
    clientState;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.PayPalFlowRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "client_state", kind: "message", T: StripeClientState },
    ]);
    static fromBinary(bytes, options) {
        return new PayPalFlowRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PayPalFlowRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PayPalFlowRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PayPalFlowRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.FamilyInviteRef
 */
export class FamilyInviteRef extends Message {
    /**
     * @generated from field: string invite_code = 1;
     */
    inviteCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.FamilyInviteRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "invite_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new FamilyInviteRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FamilyInviteRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FamilyInviteRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FamilyInviteRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.VoucherRef
 */
export class VoucherRef extends Message {
    /**
     * @generated from field: string voucher_code = 2;
     */
    voucherCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.VoucherRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "voucher_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new VoucherRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VoucherRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VoucherRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VoucherRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.ResendVerificationEmailRef
 */
export class ResendVerificationEmailRef extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.ResendVerificationEmailRef";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ResendVerificationEmailRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResendVerificationEmailRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResendVerificationEmailRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResendVerificationEmailRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.EmailVerificationRef
 */
export class EmailVerificationRef extends Message {
    /**
     * @generated from field: string verification_code = 1;
     */
    verificationCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.EmailVerificationRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "verification_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new EmailVerificationRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmailVerificationRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmailVerificationRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmailVerificationRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.PasswordResetKeyRef
 */
export class PasswordResetKeyRef extends Message {
    /**
     * @generated from field: string reset_key = 1;
     */
    resetKey = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.PasswordResetKeyRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "reset_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PasswordResetKeyRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PasswordResetKeyRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PasswordResetKeyRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PasswordResetKeyRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.DeviceLoginCodeRef
 */
export class DeviceLoginCodeRef extends Message {
    /**
     * @generated from field: string code = 1;
     */
    code = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.DeviceLoginCodeRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new DeviceLoginCodeRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeviceLoginCodeRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeviceLoginCodeRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeviceLoginCodeRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.LoginFlowRef
 */
export class LoginFlowRef extends Message {
    /**
     * @generated from field: string login_token = 1;
     */
    loginToken = "";
    /**
     * @generated from field: optional string error_message = 2;
     */
    errorMessage;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.LoginFlowRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "login_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new LoginFlowRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LoginFlowRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LoginFlowRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LoginFlowRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.InstallationCodeRef
 */
export class InstallationCodeRef extends Message {
    /**
     * @generated from field: string installation_code = 1;
     */
    installationCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.InstallationCodeRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "installation_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new InstallationCodeRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InstallationCodeRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InstallationCodeRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InstallationCodeRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.SupportRef
 */
export class SupportRef extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.SupportRef";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new SupportRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SupportRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SupportRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SupportRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.ContentRef
 */
export class ContentRef extends Message {
    /**
     * @generated from oneof no.jotta.openapi.ContentRef.ref
     */
    ref = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.ContentRef";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "file_or_folder", kind: "message", T: FileOrFolderRef, oneof: "ref" },
        { no: 12, name: "file_revision", kind: "message", T: FileRevisionRef, oneof: "ref" },
        { no: 11, name: "photo", kind: "message", T: PhotoRef, oneof: "ref" },
        { no: 2, name: "photo_in_album", kind: "message", T: PhotoInAlbumRef, oneof: "ref" },
        { no: 3, name: "photo_album", kind: "message", T: PhotoAlbumRef, oneof: "ref" },
        { no: 18, name: "face_ref", kind: "message", T: FaceRef, oneof: "ref" },
        { no: 4, name: "comment", kind: "message", T: CommentRef, oneof: "ref" },
        { no: 5, name: "trash", kind: "message", T: TrashRef, oneof: "ref" },
        { no: 6, name: "archive", kind: "message", T: ArchiveRef, oneof: "ref" },
        { no: 7, name: "sync_folder", kind: "message", T: SyncFolderRef, oneof: "ref" },
        { no: 8, name: "settings", kind: "message", T: SettingsRef, oneof: "ref" },
        { no: 9, name: "purchase", kind: "message", T: PurchaseRef, oneof: "ref" },
        { no: 10, name: "public_share", kind: "message", T: PublicShareRef, oneof: "ref" },
        { no: 13, name: "order", kind: "message", T: OrderRef, oneof: "ref" },
        { no: 14, name: "external_link", kind: "message", T: ExternalLinkRef, oneof: "ref" },
        { no: 15, name: "photos_ref", kind: "message", T: PhotosRef, oneof: "ref" },
        { no: 16, name: "help_article", kind: "message", T: HelpArticle, oneof: "ref" },
        { no: 17, name: "federated_identity", kind: "message", T: FederatedIdentityRef, oneof: "ref" },
        { no: 19, name: "vipps_flow", kind: "message", T: VippsFlowRef, oneof: "ref" },
        { no: 20, name: "family_invite", kind: "message", T: FamilyInviteRef, oneof: "ref" },
        { no: 21, name: "voucher", kind: "message", T: VoucherRef, oneof: "ref" },
        { no: 22, name: "password_reset_key", kind: "message", T: PasswordResetKeyRef, oneof: "ref" },
        { no: 23, name: "device_login_code", kind: "message", T: DeviceLoginCodeRef, oneof: "ref" },
        { no: 24, name: "login_flow_ref", kind: "message", T: LoginFlowRef, oneof: "ref" },
        { no: 25, name: "installation_code_ref", kind: "message", T: InstallationCodeRef, oneof: "ref" },
        { no: 26, name: "support_ref", kind: "message", T: SupportRef, oneof: "ref" },
        { no: 27, name: "paypal_flow", kind: "message", T: PayPalFlowRef, oneof: "ref" },
    ]);
    static fromBinary(bytes, options) {
        return new ContentRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContentRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContentRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContentRef, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.ContentRefs
 */
export class ContentRefs extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.ContentRef ref = 1;
     */
    ref = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.ContentRefs";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "ref", kind: "message", T: ContentRef, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ContentRefs().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContentRefs().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContentRefs().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContentRefs, a, b);
    }
}
